import { useToggletipBehavior } from '@src/utils/hooks/useToggletipBehavior'
import * as React from 'react'
import { CSSProp } from 'styled-components'

import * as Styles from './styles'

interface OverlayProps {
  targetElement: React.ReactElement
  positionCSS: CSSProp
  onToggle?: (...args: any[]) => any
}
export const Overlay: React.FC<OverlayProps> = ({
  targetElement,
  children,
  positionCSS,
  onToggle,
}) => {
  const { extendedTargetElement, isToggletipShown, wrapperRef } = useToggletipBehavior(
    targetElement,
    onToggle
  )
  return (
    <Styles.Relative ref={wrapperRef}>
      {extendedTargetElement}
      {isToggletipShown && (
        <Styles.Absolute positionCSS={positionCSS}>{children}</Styles.Absolute>
      )}
    </Styles.Relative>
  )
}

export default Overlay



// WEBPACK FOOTER //
// ./src/components/Overlay/index.tsx